import React, { Component, createContext } from 'react';

const defaultState = {
   dark: false,
   toggleDark: () => {},
};

const ThemeContext = createContext(defaultState);

type State = Omit<typeof defaultState, 'toggleDark'>;

export class ThemeProvider extends Component<{}, State> {
   state = {
      dark: false,
   };

   componentDidMount() {
      let isDark: any = window.localStorage.getItem('theme');
      if (isDark === 'true') {
         isDark = true;
      } else {
         isDark = false;
      }

      if (isDark) {
         this.setState({ dark: isDark });
      }
   }

   componentDidUpdate(prev: State) {
      const { dark } = this.state;

      if (prev.dark !== dark) {
         localStorage.setItem('theme', String(dark));
         document.firstElementChild?.classList.remove(
            'theme-' + (dark ? 'light' : 'dark'),
         );
         document.firstElementChild?.classList.add(
            'theme-' + (dark ? 'dark' : 'light'),
         );
      }
   }

   toggleDark = () => {
      this.setState((prev) => ({
         dark: !prev.dark,
      }));
   };

   render() {
      const { children } = this.props;
      const { dark } = this.state;
      return (
         <ThemeContext.Provider
            value={{
               dark,
               toggleDark: this.toggleDark,
            }}
         >
            {children}
         </ThemeContext.Provider>
      );
   }
}

export default ThemeContext;
